<script lang="ts">
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { Container, Text } from '@Shelly/shelly-design-system/index';
	import { getGarageImageUrlSuffix } from 'src/helpers/distance_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { format } from 'svelte-i18n';

	export let device;
	export let deviceData;
	export let hasMb = false;

	let position;
	let imageSuffix;
	$: garageType = deviceData ? deviceData.garageType : device?.garageType;
	$: garageTypeValue = typeof garageType === 'string' ? garageType : garageType?.value;
	$: statusStore = getDeviceStatus(device.id);
	$: cacheValue = $statusStore?.['distance:0']?.cvalue;
	$: hasVibration = $statusStore?.['vibration:0']?.value;
	$: distanceValue = $statusStore?.['distance:0']?.cvalue;
	$: closedPositionRange = Number(device?.closedPositionRange);
	$: closedToleranceRange = Number(device?.closedToleranceRange);

	$: {
		let threshold = 0;
		if (!isNaN(closedPositionRange) && !isNaN(closedToleranceRange)) {
			threshold = closedPositionRange + closedToleranceRange;
		}

		if (hasVibration) {
			if (distanceValue > cacheValue) {
				position = 'opening';
			} else if (distanceValue < cacheValue) {
				position = 'closing';
			} else {
				position = 'opening';
			}
			cacheValue = distanceValue;
		} else {
			position = distanceValue <= threshold ? 'closed' : 'open';
		}

		imageSuffix = getGarageImageUrlSuffix(garageTypeValue, position);
	}
</script>

<div class={classMap({ 'garage-container': !hasMb })}>
	<Container padding={hasMb ? 'l' : '0'}>
		<Text class="mb-s text-center text-color-3">
			{$format('title_garage_door', { default: 'Garage door' })}
		</Text>
		<Text styleType="h1" class="mb-s text-center text-300">
			{capFirstChar(
				$format(position === 'open' ? 'condition_operator_turn_open' : `state_${position}`, {
					default: position,
				}),
			)}
		</Text>
		<div class="d-flex justify-content-center">
			<img
				class="mt-s"
				src={`./images/onboarding/distance/${imageSuffix}`}
				alt={capFirstChar(
					$format(position === 'open' ? 'state_open_copy' : `state_${position}`, {
						default: position,
					}),
				)}
				width="250"
				height="175"
			/>
		</div>
	</Container>
</div>

<style>
	.secondary-tab-container {
		margin-top: 12px;
	}
	@media (min-width: 640px) {
		.garage-container {
			margin-left: 24px;
		}
	}

	@media (max-width: 639.98px) {
		.garage-container {
			margin-top: 24px;
			margin-bottom: 16px;
		}
	}
</style>
